import { PRIORITIES, STATUS_CLS, ROLES } from "@/lib/constants";

export const Badge = ({ tone = "neutral", children, testid, className = "" }) => (
  <span data-testid={testid} className={`badge-x ${STATUS_CLS[tone]} ${className}`}>{children}</span>
);

export const PriorityBadge = ({ p, testid }) => {
  const cfg = PRIORITIES[p] || PRIORITIES.P4;
  return (
    <span data-testid={testid} className={`badge-x ${cfg.cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot} ${p === "P1" ? "animate-pulse" : ""}`} />
      {cfg.label}
    </span>
  );
};

export const RoleBadge = ({ role }) => (
  <span className={`badge-x ${ROLES[role]?.cls || STATUS_CLS.neutral}`}>{ROLES[role]?.label || role}</span>
);

const TONES = {
  aperto: "bad", in_carico: "warn", risolto: "ok", chiuso: "neutral",
  aperta: "bad", "in corso": "warn", chiusa: "ok", "in analisi": "warn",
  conforme: "ok", "con osservazioni": "warn", "non conforme": "bad",
  "in uso": "warn", restituita: "ok", "in custodia": "warn", riconsegnato: "ok", smaltito: "neutral",
  si: "ok", no: "neutral", ok: "ok", anomalia: "bad", incidente: "bad", near_miss: "warn",
  alta: "bad", media: "warn", bassa: "neutral",
};

const LABELS = { in_carico: "in carico", near_miss: "near miss", si: "sì" };

export const StatusBadge = ({ value, testid }) =>
  value ? <Badge tone={TONES[value] || "neutral"} testid={testid}>{LABELS[value] || value}</Badge> : <span className="text-slate-500">—</span>;

export const kpiTone = (value, target) => (value >= target ? "ok" : value >= target - 5 ? "warn" : "bad");
